import React from 'react';
 
class VimeoVideo extends React.Component {
  render() {

    return (
    <div className="xvvid pd15">
    <div className="vvid">
      <h2>Dr.Karl Anderson, Natural Silver Solution Presentation</h2>
        <div style={{ padding: "42.5% 0 0 0", position: "relative" }}>
            <iframe src="https://player.vimeo.com/video/711040334?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} title="Dr.Karl Anderson Natural Silver Solution"></iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>

        {/* <iframe src="https://player.vimeo.com/video/711040334?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="1920" height="816" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" title="Dr.Karl Anderson Natural Silver Solution"></iframe> */}
    </div>  
    </div>
    );
  }

}

export default VimeoVideo
